import { BettingInformation } from '../Model/BettingInformation'
import CheckBoxValidatorProcessorPipeline from './CheckBoxValidatorProcessorPipeline'
import { IBetTypeValidator } from './IBetTypeValidator'
import { ICheckBoxValidatorProcessorPipeline } from './ICheckBoxValidatorProcessorPipeline'

export default class FirstFourValidator implements IBetTypeValidator {
  constructor() {
    this.pipeline = new CheckBoxValidatorProcessorPipeline()
  }

  isValid(bettingContext: BettingInformation): boolean {
    return this.pipeline.validate(4, bettingContext)
  }

  private pipeline: ICheckBoxValidatorProcessorPipeline
}
